import {
    useNavigate,
} from "react-router-dom";
import Carousel from "./HomeCarousel";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import "./Style.scss";
import HomeText from "../contentFiles/HomeText.json"
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import routes from '../contentFiles/Routes.json';


const Home = () => {
  const navigate = useNavigate();
  return (
    <>
      <Carousel />
      <Container fluid className="aboutContainer">
        <Row>
          <Col className="textAlignCenter">{HomeText.aboutOrg} <a href={routes.aboutUs}>read more {'>>'}</a></Col>
        </Row>
      </Container>
      <Container fluid className="programmeContainer">
        <Row>
          <Col className="textAlignCenter" ><h1>OUR PROGRAMMES <br></br><br></br></h1></Col>
        </Row>
        {/**Cards */}
        <Row className="textAlignCenter">
          <Col><Card className="customBorder1">
            <Card.Body>
              <Card.Title style={{color:'#1ac5ad', fontWeight:'bold',fontSize: '25px'}}>EDUCATION</Card.Title>
              <Card.Text>
                {HomeText.education}
              </Card.Text>
              <Button variant="primary" style={{backgroundColor:'#47b5ff', border:'1px solid #47b5ff'}} onClick={()=> navigate(routes.education)}>read more</Button>
            </Card.Body>
          </Card></Col>
          <Col><Card className="customBorder3">
            <Card.Body>
              <Card.Title style={{color:'#1ac5ad', fontWeight:'bold',fontSize: '25px'}}>HEALTH</Card.Title>
              <Card.Text>
              {HomeText.health}
              </Card.Text>
              <Button variant="primary" style={{backgroundColor:'#22e67e', border:'1px solid #22e67e'}} onClick={()=> navigate(routes.health)}>read more</Button>
            </Card.Body>
          </Card></Col>
        </Row>
        <Row className="textAlignCenter">
          <Col><Card className="customBorder4">
            <Card.Body>
              <Card.Title style={{color:'#1ac5ad', fontWeight:'bold',fontSize: '25px'}}>CARE & PROTECTION</Card.Title>
              <Card.Text>
              {HomeText.care}
              </Card.Text>
              <Button variant="primary" style={{backgroundColor:'#2de8fe', border:'1px solid #2de8fe'}} onClick={()=> navigate(routes.careAndProtection)}>read more</Button>
            </Card.Body>
          </Card></Col>
          <Col><Card className="customBorder6">
            <Card.Body>
              <Card.Title style={{color:'#1ac5ad', fontWeight:'bold',fontSize: '20px'}}>DISASTER RESPONSE</Card.Title>
              <Card.Text>
              {HomeText.environment}
              </Card.Text>
              <Button variant="primary" style={{backgroundColor:'#47b5ff', border:'1px solid #47b5ff'}} onClick={()=> navigate(routes.environment)}>read more</Button>
            </Card.Body>
          </Card></Col>
        </Row>
        {/**End Cards */}
         {/**our journey */}
         <Row className='ourjourney'>
          <Col className="textAlignCenter"><h1>Our Journey </h1></Col>
        </Row>
      <Row className='ourjourney'>
          <Col className="textAlignCenter">
            {HomeText.journey}<a href={routes.ourJourney}>read more {'>>'}</a>
          </Col>
        </Row>
        {/**Journey ends */}
        {/**Testimonials */}
        {/*
        <Row>
          <Col className="textAlignCenter"><h1><br></br>Supporter Testimonials <br></br><br></br></h1></Col>
        </Row>
      <Row>
          <Col>
            <TestimonialCarousel></TestimonialCarousel>
          </Col>
        </Row>
        {/**Testimonials end */}
       
      </Container>
      <Container fluid className="supporterContainer">
        {/*
      <Row className="textAlignCenter supporterBorder" >
          <Col><h1>Our Supporters</h1></Col>
      </Row>
      <marquee id="scroll_news" style={{ color: 'red', fontSize: '3em',height:'250px' }} direction="up" loop="-1" scrollamount="10" >
      <div onMouseOver={()=>document.getElementById('scroll_news').stop()} onMouseOut={()=>document.getElementById('scroll_news').start()}> 
      <Row className="textAlignCenter padbtm" >
          <Col>
            <img src={sup9} width="200" />
          </Col>
          <Col>
            <img src={sup2} width="200" />
          </Col>
          <Col>
            <img src={sup3} width="200" />
          </Col>
          <Col>
            <img src={sup1} width="200" />
          </Col>
          <Col>
            <img src={sup6} width="200" />
          </Col>
      </Row>
      
      <Row className="textAlignCenter padbtm" >
          <Col>
            <img src={sup16} width="200"/>
          </Col>
          <Col>
            <img src={sup5} width="200"/>
          </Col>
          <Col>
            <img src={sup8} width="200"/>
          </Col>
          <Col>
            <img src={sup4} width="200"/>
          </Col>
          <Col>
            <img src={sup10} width="200"/>
          </Col>
      </Row>
      <Row className="textAlignCenter padbtm" >
          <Col>
            <img src={sup12} width="200"/>
          </Col>
          <Col>
            <img src={sup11} width="200"/>
          </Col>
          <Col>
            <img src={sup13} width="200"/>
          </Col>
          <Col>
            <img src={sup14} width="200"/>
          </Col>
          <Col>
            <img src={sup15} width="200"/>
          </Col>
      </Row>
      <Row className="textAlignCenter padbtm" >
          <Col>
            <img src={sup7} width="200"/>
          </Col>
      </Row>
      </div>
      </marquee>*/}
      </Container>
    </>
  )


};

export default Home;